<template>
	<div>
		<div class="label">Demander l'accès</div>
		<div class="inputContainer" v-if="!isSubmitted">
			<input class="input" placeholder="EMAIL" v-model="email" />
			<button class="button" @click="saveEmail">SUBMIT</button>
		</div>
		<h2 v-else class="inMessage">
			C'est noté ! Tu receveras un mail d'accès bientôt.
		</h2>
	</div>
</template>

<script>
import { addEmailAdress } from "@/firebase.js";

export default {
	data() {
		return {
			email: "",
			isSubmitted: false,
		};
	},
	methods: {
		saveEmail() {
			addEmailAdress(this.email).then(() => {
				this.isSubmitted = true;
			});
		},
	},
};
</script>

<style scoped>
.inputContainer {
	display: flex;
	flex-wrap: wrap;
	max-width: 95%;
}
.label {
	color: white;
	font-size: 30px;
	margin-bottom: 10px;
}
.input,
.button {
	padding: 0 18px;
	border: 0;
	font-weight: bold;
	font-size: 20px;
	height: 50px;
}
.input {
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
	outline: none;
	margin: 0;
}
.button {
	background-color: #5ad75b;
	color: white;
	border: 0;
	padding: 12px 18px;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
	cursor: pointer;
}
.inMessage {
	color: #5ad75b;
}
@media only screen and (max-width: 600px) {
	.inputContainer {
		position: relative;
		justify-content: center;
	}
	.input,
	.button {
		border-radius: 4px;
	}
	.input {
		margin: 20px 0;
		width: 80%;
		border: 1px solid lightgrey;
	}
	.label {
		color: rgb(44, 62, 80);
		font-size: 24px;

		margin-bottom: 8px;
		margin-left: 20px;
	}
	.button {
		margin-top: 0px;
		width: 42%;
	}
}
</style>
